/**
 * Tek giriş noktası — frontend LoginModal
 */

export function getFrontendOrigin() {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return process.env.REACT_APP_FRONTEND_URL || 'https://www.carmengold.com';
}

/** Giriş sonrası yönlendirme (yalnızca site içi path) */
export function getPostLoginRedirect() {
  if (typeof window === 'undefined') return null;
  const redirect = new URLSearchParams(window.location.search).get('redirect');
  if (redirect && redirect.startsWith('/') && !redirect.startsWith('//')) {
    return redirect;
  }
  return null;
}

export function buildLoginUrl(redirectPath = '/hesabim') {
  const origin = getFrontendOrigin();
  const path = redirectPath.startsWith('/') ? redirectPath : `/${redirectPath}`;
  return `${origin}/?login=true&redirect=${encodeURIComponent(path)}`;
}

export function redirectAfterLogin(fallback = '/hesabim') {
  const target = getPostLoginRedirect() || fallback;
  window.location.href = target;
}
